<template>
	<div style="font-family: Bebas Neue;">
		<el-row :gutter="20">
			<el-col :span="11">
				<el-row class="stat-numbers card1 admin">
					<div class="stat-numbers-top">
						<span>覆盖学员</span>
						<div class="veido">
							<el-select
								v-model="student_region"
								placeholder="请选择"
								size="mini"
								style="width: 110px;"
								popper-class="operateDropOption"
								@change="selectStudent"
							>
								<el-option
									v-for="item in [{ name: '全部', id: null }, ...select_region]"
									:key="item.id"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
					<div id="myChart0" style="width: 100%; height: 283px"></div>
				</el-row>
			</el-col>

			<el-col :span="13">
				<el-row class="stat-numbers card2 admin">
					<div class="stat-numbers-top">
						<span>覆盖学校</span>
						<div class="veido">
							<el-select
								v-model="school_region"
								placeholder="请选择"
								size="mini"
								style="width: 110px;"
								popper-class="operateDropOption"
								@change="selectSchool"
							>
								<el-option
									v-for="item in [{ name: '全部', id: null }, ...all_region]"
									:key="item.id"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
					<div style="display: flex;">
						<div style="width: 70%; height: 290px;">
							<div style="position: absolute; top: 4px; left: 3px; width: 70%; height: 319px;" _flex="~ justify-center">
								<div id="myChart1" style="height: 319px; width: 420px;"></div>
							</div>
						</div>

						<el-table
							:data="tableData"
							:summary-method="getSummaries"
							show-summary
							height="200"
							style="width: 100%; margin-left: 10px; margin-top: 15px; margin-right: 20px; font-size: 14px;"
							:show-header="false"
							size:mini
							:cell-style="columnStyle"
						>
							<el-table-column prop="name" label="总量" width="130"> </el-table-column>
							<el-table-column prop="value" label="人数" width="100" align="right"></el-table-column>
						</el-table>
					</div>
				</el-row>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="11">
				<el-row class="stat-numbers card3 admin">
					<div class="stat-numbers-top">
						<span>课件总量</span>
					</div>
					<div id="myChart2" style="width: 100%; height: 395px; padding-bootm: 50px;"></div>
				</el-row>
			</el-col>

			<el-col :span="13">
				<el-row class="stat-numbers card4 admin">
					<div class="stat-numbers-top">
						<span>题量</span>
            <div class="veido">
							<el-select
								v-model="question_grade"
								placeholder="请选择"
								size="mini"
								style="width: 110px;"
								popper-class="operateDropOption"
                @change="selectQuestionGrade"
							>
								<el-option
									v-for="item in [
                    { name: '全部', id: null },
                    ...Object.entries(gradeMap).map(([id, name]) => {
                      return { id, name }
                    })
                  ]"
									:key="item.id"
									:label="item.name"
									:value="item.id"
								>
								</el-option>
							</el-select>
						</div>
					</div>
					<div id="myChart3" style="width: 100%; height: 240px; padding-bootm: 50px;"></div>
					<div class="stat-numbers-top" style="margin-top: 4px; margin-left: 15px;">
						<span style="font-size: 14px; color: '#4E4E4E';">{{ gradeMap[question_grade] || '全年级' }}-题型分布</span>
					</div>
					<el-row :gutter="20" class="Subjects" style="margin-top: 5px; margin-right: 1px;">
						<el-col :span="6">
							<div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">单选题</span>
									<span class="SubjectsValue" style="">{{ question.type[1] || 0 }}</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">多选题</span>
									<span class="SubjectsValue" style="">{{ question.type[2] || 0 }}</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">填空题</span>
									<span class="SubjectsValue" style="">{{ question.type[3] || 0 }}</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">连线题</span>
									<span class="SubjectsValue" style="">{{ question.type[11] || 0 }}</span>
								</div>
							</div>
						</el-col>
            <el-col :span="6"
							><div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">排序题</span>
									<span class="SubjectsValue" style="">{{ question.type[10] || 0 }}</span>
								</div>
							</div></el-col
						>
            <el-col :span="6" v-show="myChart3_Selected['音乐']"
							><div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<!-- <span class="SubjectsTitle" style="">可视化演唱题</span> -->
                  <span class="SubjectsTitle" style="">演唱题</span>
									<span class="SubjectsValue" style="">{{ question.type[9] || 0 }}</span>
								</div>
							</div></el-col
						>
						<el-col :span="6" v-show="myChart3_Selected['音乐']">
							<div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">节奏题</span>
									<span class="SubjectsValue" style="">{{ question.type[4] || 0 }}</span>
								</div>
							</div>
						</el-col>
						<el-col :span="6" v-show="myChart3_Selected['音乐']"
							><div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">视唱旋律题</span>
									<span class="SubjectsValue" style="">{{ question.type[5] || 0 }}</span>
								</div>
							</div></el-col
						>
						<el-col :span="6" v-show="myChart3_Selected['音乐']"
							><div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">识音练习题</span>
									<span class="SubjectsValue" style="">{{ question.type[18] || 0 }}</span>
								</div>
							</div></el-col
						>
						<el-col :span="6" v-show="myChart3_Selected['美术']"
							><div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">填充题</span>
									<span class="SubjectsValue" style="">{{ question.type[12] || 0 }}</span>
								</div>
							</div></el-col
						>
						<el-col :span="6" v-show="myChart3_Selected['美术']"
							><div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">拼图题</span>
									<span class="SubjectsValue" style="">{{ question.type[13] || 0 }}</span>
								</div>
							</div></el-col
						>
						<el-col :span="6" v-show="myChart3_Selected['美术']">
              <div class="grid-content bg-purple">
								<div style="display: flex; align-items: center; justify-content: space-between;">
									<span class="SubjectsTitle" style="">配色题</span>
									<span class="SubjectsValue" style="">{{ question.type[14] || 0 }}</span>
								</div>
							</div></el-col
						>
					</el-row>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import * as echarts from 'echarts'
import '@/assets/js/anhui.js'
import '@/assets/js/aomen.js'
import '@/assets/js/beijing.js'
import '@/assets/js/chongqing.js'
import '@/assets/js/fujian.js'
import '@/assets/js/gansu.js'
import '@/assets/js/guangdong.js'
import '@/assets/js/guangxi.js'
import '@/assets/js/guizhou.js'
import '@/assets/js/hainan.js'
import '@/assets/js/hebei.js'
import '@/assets/js/heilongjiang.js'
import '@/assets/js/henan.js'
import '@/assets/js/hubei.js'
import '@/assets/js/hunan.js'
import '@/assets/js/jiangxi.js'
import '@/assets/js/jiangsu.js'
import '@/assets/js/jilin.js'
import '@/assets/js/liaoning.js'
import '@/assets/js/nanjing.js'
import '@/assets/js/taiwan.js'
import '@/assets/js/neimenggu.js'
import '@/assets/js/ningxia.js'
import '@/assets/js/qinghai.js'
import '@/assets/js/shandong.js'
import '@/assets/js/shanghai.js'
import '@/assets/js/shanxi.js'
import '@/assets/js/shanxi1.js'
import '@/assets/js/sichuan.js'
import '@/assets/js/tianjin.js'
import '@/assets/js/xianggang.js'
import '@/assets/js/xinjiang.js'
import '@/assets/js/xizang.js'
import '@/assets/js/yunnan.js'
import '@/assets/js/zhejiang.js'
import china from '@/assets/js/china.json'
echarts.registerMap('china', china)
const _ = require('lodash')
const gradeMap = {
	1: '一年级',
	2: '二年级',
	3: '三年级',
	4: '四年级',
	5: '五年级',
	6: '六年级',
	7: '初一',
	8: '初二',
	9: '初三',
	10: '高一',
	11: '高二',
	12: '高三'
}
export var QuestionsData = []

export default {
	data() {
		return {
			gradeMap,
			select_region: [],
			all_region: [],
			tableData: [],
			schoolMap: 'china',
      myChart3_Selected: {
        '音乐': true,
        '美术': true
      },
      student: {},
      school: {},
      courseware: {},
      question: {},
      student_region: null,
      school_region: null,
			question_grade: null
		}
	},
	mounted() {
		this.refreshDataList()
	},
	methods: {
		async refreshDataList() {
      const [all_region, select_region]  = await Promise.all([
        this.$api.account.Gitdiqu(0),
        this.$api.user.httpGet(`statistic-region`)
      ])
			this.all_region = all_region
			this.select_region = select_region
      this.getStudentStatistics() // 莫名原因首次加载只有这个元素的节点会找不到
			this.getQuestionStatistics()
      this.getPPTStatistics()
      this.getSchoolStatistics()
		},
    async getSchoolStatistics(region) {
      this.school = await this.$api.user.httpGet(`statistic-school`, {
        school_region: this.school_region
      })
      this.tableData = region ? this.school.child : this.school
      this.schoolMap = region ? this.school.title : 'china'
      this.drawSchool()
    },
    async getPPTStatistics() {
      this.courseware = await this.$api.user.httpGet(`statistic-ppt`)
			this.drawPPT()
    },
    async getStudentStatistics() {
      this.student = await this.$api.user.httpGet(`statistic-student`, {
				student_region: this.student_region
      })
			this.drawStudent()
    },
		async getQuestionStatistics() {
			this.question = await this.$api.user.httpGet(`statistic-question`, {
				grade: this.question_grade
			})
			this.question.grade = this.question.grade.map(item => {
				return {
					...item,
					value: _.values(item.value)
				}
			})
			this.drawQuestion()
		},
		async selectStudent(a) {
      this.student_region = a
      this.getStudentStatistics()
		},
		async selectSchool(region) {
      this.school_region = region
      this.getSchoolStatistics(region)
		},
    async selectQuestionGrade(grade) {
      this.question_grade = grade
      this.getQuestionStatistics()
    },
		columnStyle({ row, column, rowIndex, columnIndex }) {
			if (columnIndex == 0) {
				if (columnIndex == 0) {
					return 'font-size: 13px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #6D6D6D;-webkit-background-clip: text'
				}
				return 'font-size: 13px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #6D6D6D;-webkit-background-clip: text'
			}
			if (columnIndex == 1) {
				if (columnIndex == 0) {
					return 'font-size: 13px;font-family: PingFang SC-Medium, PingFang SC;font-weight: 500;color: #000000;-webkit-background-clip: text;'
				}
				return 'font-size: 13px;font-family: PingFang SC-Medium, PingFang SC;font-weight: 600;color: #000000;-webkit-background-clip: text;'
			}
		},
		getSummaries(param) {
			const { columns, data } = param
			const sums = []
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '总量'
					return
				}
				const values = data.map(item => Number(item[column.property]))
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr)
						if (!isNaN(value)) {
							return prev + curr
						} else {
							return prev
						}
					}, 0)
					sums[index]
				} else {
					sums[index] = 'N/A'
				}
			})

			return sums
		},
		drawStudent() {
			var option = {
				title: [
					{
						text: `{val|${this.student.total}}\n{name|学员}`,
						top: 'center',
						left: 'center',
						textStyle: {
							rich: {
								name: {
									fontSize: 14,
									color: '#8F8F91',
									padding: [0, 0, 0, 0]
								},
								val: {
									fontSize: 22,
									fontWeight: 'bold',
									color: '#333333',
									padding: [-30, 0, 0, 0]
								}
							}
						}
					}
				],
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(254,254,254,0.9)',
					borderColor: 'transparent'
				},
				legend: {
					top: 250,
					icon: 'circle',
					itemWidth: 17, //类目原型宽度
					itemHeight: 13, //类目原型高度
					itemGap: 40,
					textStyle: {
						rich: {
							name: {
								fontSize: 14,
								padding: [2, 0, 0, 0] //上，右，下，左
							},
							num: {
								fontSize: 14,
								fontWeight: 600,
								padding: [3, 0, 0, 0]
							}
						}
					},
					formatter: (name) => {
            const v = this.student.school_type.find(item => item.name == name)?.value
            return [`{name|${name}}`, `{num|${v}}`].join('  ')
          }
				},
				color: ['#40E1A4', '#FFB613', '#3BB2F5'],
				series: [
					{
						type: 'pie',
						radius: ['55%', '65%'],
						avoidLabelOverlap: false,
						center: ['50%', '45%'],
						itemStyle: {
							borderRadius: 2,
							borderColor: '#fff',
							borderWidth: 2
						},
						label: {
							show: false,
							position: 'center'
						},
						emphasis: {
							label: {
								show: false
							}
						},
						labelLine: {
							show: false
						},
						data: this.student.school_type
					}
				]
			}
			setTimeout(() => {
				let myChart0 = echarts.init(document.getElementById('myChart0'))
				option && myChart0.setOption(option)
				window.addEventListener('resize', () => {
					myChart0.resize()
				})
			}, 1000)
		},
drawSchool() {
  let that = this;
  // 单省份下钻时按省份调整地图中心位置与缩放(画布 420x319，基准中心 50%/50%)
  // 数值由原 offsetCenter 像素值换算而来，可视情况微调
  const provinceConfig = {
    '默认': { layoutCenter: ['50%', '50%'], zoom: 1 },   // 兜底(含中国地图)
    '黑龙江': { layoutCenter: ['50%', '66%'], zoom: 1 },
    '福建': { layoutCenter: ['50%', '40%'], zoom: 0.9 },
    '甘肃': { layoutCenter: ['60%', '60%'], zoom: 0.8 },
		'宁夏': { layoutCenter: ['50%', '50%'], zoom: 0.8 },
		'上海': { layoutCenter: ['50%', '50%'], zoom: 0.88 },
	};
	console.error(this.schoolMap, '=')
  const prov = provinceConfig[this.schoolMap] || provinceConfig['默认'];
	console.log('schoolMap', this.schoolMap)
  var option = {
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        var result = '';
        result += `<span style="width: 42px;height: 28px;font-size: 14.5px;font-family: PingFang SC-Medium, PingFang SC;font-weight: 800;color: #000000;line-height: 28px;-webkit-background-clip: text;">${params.name}</span>
        </br>
        总量
        &nbsp&nbsp
        ${params.value || 0}
        `;
        return result;
      }
    },
    dataRange: {
      min: 0,
      max: 1,
      show: false,
      color: ['#FF7300', '#FF7300', '#F2F2F2'],
      calculable: true
    },
    // ✅ 1. 将 regions 和地图基础配置移入 geo 组件
    geo: {
      map: this.schoolMap, // 注意：geo 中使用 map，不是 mapType
      roam: false,
      layoutSize: 315,
      // 中国地图默认居中；单省份下钻时按省份偏移中心点与缩放
      layoutCenter: prov.layoutCenter,
      aspectScale: 1.0,
      zoom: prov.zoom,
      label: {
        show: false
      },
      itemStyle: {
        borderColor: '#C86A7A',
        borderWidth: 1,
        borderType: 'solid',
        areaColor: '#F1F1F1',
        shadowBlur: 0,
        shadowColor: '#F1F1F1',
        shadowOffsetX: 0,
        shadowOffsetY: 0
      },
      emphasis: {
        itemStyle: {
          areaColor: 'rgba(255, 135, 0, 1)'
        },
        label: {
          show: false
        }
      },
      select: {
        show: false,
        disabled: false,
        label: {
          show: false
        },
        itemStyle: {
          areaColor: '#FF7300'
        }
      }
    },
    series: [
      {
        type: 'map',
        geoIndex: 0, // ✅ 3. 关键！关联到上面的 geo 组件
        selectedMode: false,
        silent: false,
        data: this.tableData
      }
    ]
  };

  setTimeout(function () {
    let myChart1 = echarts.init(document.getElementById('myChart1'));
    option && myChart1.setOption(option, true);
    window.addEventListener('resize', () => {
      myChart1.resize();
    });
    myChart1.on('click', param => {
      if (!param.data?.child) return;
      that.selectSchool(param.data.id);
      myChart1.off('click');
    });
  }, 10);
},
		async drawPPT() {
      await new Promise(res => setTimeout(() => { res() }, 1000))
			var option = {
				title: [
					{
						text: `{val|${this.courseware.total}份}\n{name|课件}`,
						top: 'center',
						left: 'center',
						textStyle: {
							rich: {
								name: {
									fontSize: 14,
									color: '#8F8F91',
									padding: [10, 0, 0, 0]
								},
								val: {
									fontSize: 22,
									fontWeight: 'bold',
									color: '#333333',
									padding: [10, 0, 0, 0]
								}
							}
						}
					}
				],
				tooltip: {
					trigger: 'item',
					backgroundColor: 'rgba(254,254,254,0.9)',
					borderColor: 'transparent'
				},
				toolbox: {
					show: true
				},
				series: [
					{
						type: 'pie',
						radius: [60, 110],
						center: ['50%', '50%'],
						roseType: 'radius',
						itemStyle: {
							borderRadius: 2,
							normal: {
								labelLine: {
									length: 45,
									lineStyle: {
										type: 'dotted',
										width: 2.5
									}
								},
								color: list => {
									var colorList = [
										{
											colorStart: '#FFC069',
											colorEnd: '#fadfba'
										},
										{
											colorStart: '#84E4AA',
											colorEnd: '#98F0E7'
										},
										{
											colorStart: '#A5B9FF',
											colorEnd: '#2CC2F1'
										}
									]
									return new echarts.graphic.LinearGradient(1, 0, 0, 0, [
										{
											offset: 0,
											color: colorList[list.dataIndex]['colorStart']
										},
										{
											offset: 1,
											color: colorList[list.dataIndex]['colorEnd']
										}
									])
								}
							}
						},
						label: {
							show: true,
							fontSize: 14,
							formatter: '{b}:{c}'
						},
						data: this.courseware.school_type.sort(function (a, b) {
							return a.value - b.value
						})
					}
				]
			}
			setTimeout(function () {
				let myChart2 = echarts.init(document.getElementById('myChart2'))
				option && myChart2.setOption(option)
				window.addEventListener('resize', () => {
					myChart2.resize()
				})
			}, 1)
		},
		drawQuestion() {
			var option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						lineStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [
									{
										offset: 0,
										color: 'rgba(255,158,69,1)' // 0% 处的颜色
									},
									{
										offset: 0.5,
										color: 'rgba(255,158,69,1)' // 0% 处的颜色
									},
									{
										offset: 1,
										color: 'rgba(255,158,69,1)' // 100% 处的颜色
									}
								],
								global: false
							}
						}
					},
					extraCssText: 'width:165px;height:70px;',
					backgroundColor: 'rgba(254,254,254,0.7)',
					borderColor: 'transparent',
					formatter: (params) => {
						var result = ''
						result += `<span style=" width: 42px;height: 28px;font-size: 14.5px;
font-family: PingFang SC-Medium, PingFang SC;font-weight: 800;color: #000000;line-height: 28px;-webkit-background-clip: text;">${params[0]?.axisValue}</span>
							</br>
							${params[0]?.seriesName}&nbsp&nbsp
							${params[0]?.data || 0}&nbsp&nbsp&nbsp&nbsp
							${params[1]?.seriesName ? params[1]?.seriesName + '&nbsp&nbsp' + (params[1]?.data || 0) : ''}`
						return result
					}
				},
				legend: {
					left: 'left',
					icon: 'circle',
					top: '2',
					itemWidth: 30,
					itemHeight: 10,
					itemGap: 40,
					textStyle: {
						rich: {
							name: {
								fontSize: 14,
								color: '#636363',
								padding: [2, 0, 0, 0]
							},
							num: {
								fontSize: 16,
								fontWeight: 600,
								padding: [2, 0, 0, 0]
							}
						}
					},
					formatter: (name) => {
						const select = this.question.total.find(item => item.subject_name == name )
            const v = select.total
						return [`{name|${name}}  `, `{num|${v}}`].join('  ')
					}
				},
				grid: {
					show: false,
					top: '21%',
					left: '1%',
					right: '2%',
					bottom: '1%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: Object.values(this.gradeMap)
				},
				yAxis: {
					gridIndex: 0
				},
				series: [
					{
						name: '音乐',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 8,
						itemStyle: {
							color: '#1BD3FF',
              borderColor: '#ffffff',
              borderWidth: 2
						},
            lineStyle: {
              width: 3
            },
						data: this.question.grade[0].value
					},
					{
						name: '美术',
						type: 'line',
						smooth: true,
						symbol: 'circle',
						symbolSize: 8,
						itemStyle: {
							color: '#40E1A4',
              borderColor: '#ffffff',
              borderWidth: 2
						},
            lineStyle: {
              width: 3
            },
						data: this.question.grade[1].value
					}
				]
			}
			setTimeout(() => {
				let myChart3 = echarts.init(document.getElementById('myChart3'))
				option && myChart3.setOption(option)
				window.addEventListener('resize', () => {
					myChart3.resize()
				})
				myChart3.on('click', param => {
					this.question_grade = String(param.dataIndex + 1)
					this.getQuestionStatistics()
          myChart3.off('click')
				})
        myChart3.on('legendselectchanged', (params) => {
          // 书荣~又不要了
          // this.myChart3_Selected = params.selected
        })
			}, 1)
		},
	}
}
</script>

<style lang="scss" scoped>
/deep/.el-table {
	display: flex;
	flex-direction: column;
}
/deep/.el-table__body-wrapper {
	order: 1;
}
/deep/.el-table tbody tr td:nth-child(1),
.el-table tbody tr th:nth-child(1),
.el-table thead tr td:nth-child(1),
.el-table thead tr th:nth-child(1) {
	padding-left: 3px;
}
/deep/.el-table tbody tr td:last-child,
.el-table thead tr td:last-child {
	padding-right: 3px !important;
}
/deep/.el-table .el-table__cell {
	padding: 8.5px 0;
	min-width: 0;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
	text-overflow: ellipsis;
	vertical-align: middle;
	position: relative;
	text-align: left;
}

/*合计字体颜色*/
/* .el-table__footer-wrapper tbody td:nth-child(2) {
background-color: #fffaf7;
	color: #000000;
	order: 1;
  }
 .el-table__footer-wrapper tbody td:nth-child(1){
    color: red;
    cursor: auto;
  } */

/deep/.el-table__footer-wrapper tbody td.el-table__cell {
	background-color: #fffaf7;
	color: #000000;
	order: 1;
}

/deep/::-webkit-scrollbar {
	width: 2px;
}
// 滚动条的滑块
/deep/::-webkit-scrollbar-thumb {
	background-color: #f1f1f1;
	border-radius: 2px;
}

// 修改表格(el-table)的滚动条
/deep/.el-table__body-wrapper::-webkit-scrollbar {
	width: 5px;
	height: 5px !important;
}
// 滚动条的滑块
/deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
	background-color: #f1f1f1;
	border-radius: 2px;
}

/deep/.SubjectsTitle {
	font-size: 12px;
	font-family: PingFang SC-Regular, PingFang SC;
	font-weight: 400;
	color: #6d6d6d;
	line-height: 29px;
	-webkit-background-clip: text;
	margin-left: 8px;
}
/deep/.SubjectsValue {
	font-size: 14px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 550;
	color: #000000;
	line-height: 29px;
	-webkit-background-clip: text;
	margin-right: 8px;
}

/deep/.stat-numbers.card1 {
	// width: 742px;
	height: 330px;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	box-sizing: border-box;
	background-color: white;
	margin-top: 1px;
}

/deep/.stat-numbers.card2 {
	// width: 920px;
	height: 330px;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	box-sizing: border-box;
	background-color: white;
	margin-left: -10px;
	margin-top: 1px;
	/deep/.el-table {
		display: flex;
		flex-direction: column;
	}
}

/deep/.stat-numbers.card3 {
	// width: 742px;
	height: 500px;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	box-sizing: border-box;
	background-color: white;
	margin-top: 6px;
}

/deep/ .el-table__body-wrapper.is-scrolling-left {
  overflow-x: hidden;
}
/deep/.stat-numbers.card4 {
	// width: 920px;
	height: 500px;
	border: 1px solid #ebeef5;
	border-radius: 8px;
	box-sizing: border-box;
	background-color: white;
	margin-left: -10px;
	margin-top: 6px;
}

/deep/.stat-numbers.admin {
	color: #707070;
	font-size: 14.5px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 600;
	padding-left: 10px;
}

/deep/.stat-numbers-top {
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 5px;
	margin-left: 8px;
	margin-right: 11px;
	.el-select > .el-input .el-input__inner {
		background: #f8f9fd;
		border: 0;
	}
}

/deep/.Subjects {
	margin-bottom: 10px;
	&:last-child {
		margin-bottom: 0;
	}
}
/deep/.el-col {
	border-radius: 4px;
}
/deep/.bg-purple-dark {
	background: #f8f9fd;
}
/deep/.bg-purple {
	background: #f8f9fd;
}
/deep/.bg-purple-light {
	background: #f8f9fd;
}
/deep/.grid-content {
	border-radius: 6px;
	min-height: 29px;
  margin-bottom: 15px;
}
/deep/.row-bg {
	padding: 10px 0px;
	background-color: #f8f9fd;
}
</style>
